module.exports = __webpack_public_path__ + "assets/img/20210924-3.d78433dd.png";